import VueRouter from "vue-router";
import Vue from "vue";
import store from "../store";
import WikiMainPageManageAccess from "./WikiMainPageManageAccess.vue";
import WikiPageInMyStuff from "./WikiPageInMyStuff.vue";
import WikiStoreModule from "./store";
import {getWikiChildren, getMainWikiPageName} from './WikiChildrenPages';
import {ROUTER_NAME_PREFIX, MAIN_URL_PREFIX} from "./config";
import WikisSharedList from "./WikisSharedList.vue";
import WikiMainRouter from "./WikiMainRouter.vue";
import {CurrentUserClass} from "shared/CurrentUser";
import WikiPageReports from '~/angular/app/wiki_page/reports/WikiPageReports.vue';

WikiBindController.$inject = ['$scope'];

function WikiBindController($scope) {


    function initVue() {
        store.registerModule('WikiStore', WikiStoreModule);
        const router = new VueRouter({
            mode: 'history',
            routes: [
                {
                    path: MAIN_URL_PREFIX + 'list/',
                    component: WikisSharedList,
                    name: 'WikisSharedList',
                    props: true,
                },
                {
                    path: MAIN_URL_PREFIX + ':wikiId(\\d+)/manage-access/',
                    component: WikiMainPageManageAccess,
                    name: 'MainWikiPageManageAccess',
                    props: true,
                },
                {
                    path: MAIN_URL_PREFIX + ':wikiId(\\d+)/reports/',
                    component: WikiPageReports,
                    name: 'MainWikiPageReports',
                    props: true,
                },
                {
                    path: MAIN_URL_PREFIX + ':wikiId(\\d+|my)/:accessCode([a-zA-Z0-9_@!$\-]{10,100})?/',
                    component: WikiPageInMyStuff,
                    name: 'WikiPageInMyStuff',
                    props: route => ({
                        accessCode: route.params.accessCode,
                        wikiId: (route.params.wikiId === 'my') ? (new CurrentUserClass().wiki_id||route.params.wikiId) : route.params.wikiId
                    }),
                    children: getWikiChildren(ROUTER_NAME_PREFIX)
                },
                {
                    path: MAIN_URL_PREFIX + ':wikiId(\\d+)/code/:accessCode/', redirect: to => {
                        return {
                            name: getMainWikiPageName(ROUTER_NAME_PREFIX),
                            params: {
                                wikiId: to.params.wikiId,
                                accessCode: to.params.accessCode,
                            }
                        };
                    }
                },
            ]
        });

        const vm = new Vue({
            el: '#WikiBindController',
            router,
            store,
            render(createElement, context) {
                const {props: attrs} = this;
                return createElement(WikiMainRouter, {attrs});
            }
        });

        $scope.$on('$destroy', () => {
            if (vm) {
                vm.$destroy();
            }
        });
    }

    initVue();

}

export default WikiBindController;
